import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/common/Dashboard";
import FeaturedForm from "../pages/common/FeaturedForm";
import NewOffer from "../pages/common/NewOffer";
import OfferList from "../pages/common/OfferList";
import StoreForm from "../pages/Merchant/StoreForm";
import StoreList from "../pages/Merchant/StoreList";
import Welcome from "../pages/common/Welcome";
import MerchantOnboardLayout from "../components/Merchant/MerchantOnboarding/MerchantOnboardLayout";
import WelcomeOfferLayout from "../pages/Merchant/WelcomeOfferLayout";
import GettingStarted from "../pages/Merchant/GettingStarted";
// import SetUpAccount from "../components/Merchant/MerchantOnboarding/SetUpAccountOld";
import CreateAccount from "../pages/Merchant/CreateAccount";
import AccountCreated from "../pages/Merchant/AccountCreated";
import AccountLogin from "../pages/Merchant/AccountLogin";
import SetUpAccount from "../pages/Merchant/SetUpAccount";
import RedemptionForm from "../pages/Merchant/RedemptionForm";
import { useSelector } from "react-redux";
import PrivateRoute from "./PrivateRoute";
import EditProfileForm from "../pages/Merchant/EditProfileForm";

const MerchantRoutes = () => {
  const token = useSelector((state) => state?.authReducer?.tokenData?.token);
  const role = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.role
  );

  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const isRoleMatching = isAuthenticated && role == "merchant";
  const getRedirectPath = () => {
    switch (role) {
      case "merchant":
        return "/merchant/dashboard";
      // return "/merchant/welcome";
      case "fundraiser":
        return "/fundraiser/dashboard";
      default:
        return "/dashboard"; // Default dashboard
    }
  };

  useEffect(() => {
    setIsAuthenticated(!!token);
  }, [token]);

  return (
    <Routes>
      <Route
        path="/merchant/dashboard"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <Dashboard />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="/merchant/offer-form"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <NewOffer merchant={true} />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/merchant/offer-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <OfferList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="/merchant/franchise-form"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <StoreForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/merchant/franchise-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <StoreList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="/merchant/edit-profile"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <EditProfileForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/merchant/welcome"
        element={
          isRoleMatching ? <Welcome /> : <Navigate to={getRedirectPath()} />
        }
      />
      <Route
        path="/merchant/welcome-offer"
        element={
          isRoleMatching ? (
            <WelcomeOfferLayout />
          ) : (
            <Navigate to={getRedirectPath()} />
          )
        }
      />
      <Route
        path="/merchant/getting-started/:referralCode?"
        element={
          <MerchantOnboardLayout
            element={
              // !isAuthenticated ? (
              <GettingStarted />
              // ) : (
              //   <Navigate to={getRedirectPath()} />
              // )
            }
          />
        }
      />
      {/* <Route
                path="/account-setup"
                element={<MerchantOnboardLayout element={<SetUpAccount1/>} />}
              /> */}
      <Route path="/account-setup" element={<SetUpAccount />} />
      {/* <Route
                path="/create-account"
                element={<MerchantOnboardLayout element={<CreateAccount/>} />}
              /> */}
      <Route
        path="/welcome-onboard/:verificationCode"
        element={<MerchantOnboardLayout element={<CreateAccount />} />}
      />
      <Route
        path="/account-created"
        element={<MerchantOnboardLayout element={<AccountCreated />} />}
      />
      <Route
        path="/merchant/account-login"
        element={<MerchantOnboardLayout element={<AccountLogin />} />}
      />
      <Route
        path="/merchant/redemption"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <RedemptionForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
    </Routes>
  );
};

export default MerchantRoutes;
